import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSkillCreated.meta';

export type UseTrackSkillCreatedParams = {
  skill_id: string;
  scope: 'private' | 'workspace';
};

export const useTrackSkillCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillCreated = useCallback(
    (params: UseTrackSkillCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSkillCreated };
};
